export default __webpack_public_path__ + "static/media/msg-chat.9df21339.svg";